/**
 * This function returns the ids which are active for a given form field name on a given form.
 * If no form field or options match, an empty array is returned.
 * @param fieldName    Name of Form field values should be retrieved from
 * @param form         Form object which contains the data
 * @param entityStatus Entity Status Enum object
 */

export const generateDropDownOptions = (fieldName, form, entityStatus) => {
  const formField = findValue(form, fieldName);

  if (!formField) return [];

  const allFieldValues = [...(formField.values || [])];
  const activeValues = allFieldValues?.filter(
    ({ status }) => status === entityStatus.Active
  );

  const options = [];

  if (!activeValues?.length) return [];

  activeValues.forEach(({ id, label: { fallback } }) => {
    options.push({
      id,
      fallback,
    });
  });

  return options;
};

const findValue = (form, fieldName) => {
  let workingReturnValue = null;
  let returnValue = form?.find(
    ({ property: { name } = {} }) => name === fieldName
  );

  if (returnValue) return returnValue;

  form?.forEach(({ children }) => {
    if (!children) return;

    returnValue = findValue(children, fieldName);

    if (!returnValue) return;

    workingReturnValue = returnValue;
  });

  return workingReturnValue;
};
